import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/mindmaster/$")({
  beforeLoad: ({ params }) => {
    const rest = (params as { _splat?: string })._splat ?? "";
    if (rest.startsWith("group")) throw redirect({ to: "/mastermind", statusCode: 301 });
    throw redirect({ to: "/konsultacje", statusCode: 301 });
  },
});
